import { clsx } from 'clsx';
import _map from 'lodash/map';
import Stack from '../../../_components/Stack';
import { Button } from '../../Button';
import { FeaturedIcon } from '../../FeaturedIcon';
import { Link } from '../../Link';
import EmptyStateDescription from '../components/EmptyStateDescription';
import EmptyStateTitle from '../components/EmptyStateTitle';
import { containerVariants, descriptionVariants, titleVariants } from '../styles';
import type { EmptyStateDefaultProps } from '../types';

function EmptyStateDefault(props: EmptyStateDefaultProps) {
  const { title, Icon, variant, description, buttons, size = 'md', learnMore, slotProps } = props;
  const containerClassName = containerVariants({ variant, size });
  const titleClassName = titleVariants({ variant, size });
  const descriptionClassName = descriptionVariants({ variant, size });
  const buttonVariant = size === 'sm' ? 'outline' : 'solid';

  return (
    <Stack
      alignItems="start"
      className={clsx(containerClassName, props.containerClassname)}
      direction="column"
      justifyContent="center"
    >
      {Icon ? (
        <FeaturedIcon color="gray" Icon={Icon} size={size} {...slotProps?.featuredIcon} />
      ) : null}
      <Stack className="gap-y-xs items-start">
        <Stack>
          <EmptyStateTitle className={clsx(titleClassName, props.titleClassname)} title={title} />
          {description ? (
            <EmptyStateDescription className={descriptionClassName} description={description} />
          ) : null}
        </Stack>
        {learnMore ? (
          <Link
            className="font-semibold"
            color="brand"
            href={learnMore.href}
            size="sm"
            target="_blank"
          >
            {learnMore.label}
          </Link>
        ) : null}
      </Stack>
      {buttons?.length ? (
        <Stack className="gap-x-lg" direction="row">
          {_map(buttons, (button, index) => {
            return (
              <Button
                color="brand"
                key={`${button.label} ${index}`}
                size={size}
                variant={buttonVariant}
                {...button}
              >
                {button.label}
              </Button>
            );
          })}
        </Stack>
      ) : null}
    </Stack>
  );
}

export default EmptyStateDefault;
